import Chart from "react-apexcharts";

const PieChart = (props) => {
  const { series, options } = props;
  const safeSeries = Array.isArray(series) ? series.map((v) => Number(v) || 0) : [];
  const hasData = safeSeries.length > 0 && safeSeries.some((v) => v > 0);

  if (!hasData) {
    return (
      <div className="flex h-full min-h-[8rem] items-center justify-center text-sm text-gray-400">
        No data
      </div>
    );
  }

  const safeOptions = options && typeof options === "object" ? options : {};

  return (
    <Chart
      options={{
        ...safeOptions,
        chart: {
          ...(safeOptions.chart || {}),
          animations: { enabled: false },
          events: {
            ...(safeOptions.chart?.events || {}),
            mouseMove: (event, chartContext) => {
              if (!chartContext?.w?.globals?.dom?.baseEl) return;
              safeOptions.chart?.events?.mouseMove?.(event, chartContext);
            },
            mouseLeave: (event, chartContext) => {
              if (!chartContext?.w?.globals?.dom?.baseEl) return;
              safeOptions.chart?.events?.mouseLeave?.(event, chartContext);
            },
          },
        },
      }}
      type="pie"
      width="100%"
      height="100%"
      series={safeSeries}
    />
  );
};

export default PieChart;
